import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";

export const CommunitySwitcher = () => {
  const { communities, active, setActive } = useAuth();
  if (!active) return null;
  return (
    <div>
      <div className="rg-label mb-1.5">Community</div>
      <Select value={active.id} onValueChange={setActive}>
        <SelectTrigger data-testid="community-selector" className="h-auto border-[#1E2D4A] bg-[#0B1120] py-2 text-left">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="border-[#1E2D4A] bg-[#0B1120]">
          {communities.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`community-option-${c.id}`}>
              <div className="font-display text-base font-semibold uppercase tracking-wide">{c.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{c.tagline}</div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
